import { getRouteObject } from "@/functions/getRoute";
import { simple_pages_helper } from "@/helpers/simple_pages_helper";
import { Content } from "@/ui";
import { notFound } from "next/navigation";
import React from "react";
import { createTitle } from "@/functions/createTitle";
import sn from "@/snippets";

export default function Page({ content }) {
  return (
    <>
      <Content items={content} />
    </>
  );
}


export async function getStaticProps() {
  const route = getRouteObject("ypoAwardedSupplier");
  const page = simple_pages_helper.find(route.id, "id");

  if(!page) {
    return {notFound: true};
  }

  return {
    props: {
      meta: { title: createTitle(page.title) },

      content : [
        {
          component: "BreadcrumbNavigation",
          props: {
            items: [
              { label: page.title, href: route.url },
            ],
          },
        },
        sn.header({ page }),
        ...sn.narrativePanels({
          className: "pt-4 pb-md-5",
          items: page.narrative_panels.slice(0,2)
        }),
        sn.statCounterWidget({ page }),
        sn.trendingJobs({ page }),
        ...sn.narrativePanels({
          className: "mb-4 pb-md-5",
          items: page.narrative_panels.slice(2,3)
        }),
        sn.featureTabs({ page }),
        sn.form({ page }),
      ],
    }
  }
}